import styled from 'styled-components';
import PropTypes from 'prop-types';
import BaseBox from '@tds/core-box';
import { colorTelusPurple } from '@tds/core-colours';
import { Link } from 'react-router-dom';

export const AppWrapper = styled.div`
  background-color: white;
`;

export const DashboardWrapper = styled(BaseBox)`
  height: 100%;
`;

export const TopbarWrapper = styled(BaseBox)`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  background: ${colorTelusPurple};
  width: 100%;
  padding: 0.7rem 2rem;
  justify-content: space-between;
  @media screen and (max-width: 992px) {
    padding: 16px;
  }
`;

export const SidebarWrapper = styled(BaseBox)`
  ul {
    display: table;
  }
  ul li {
    margin-right: 20px;
    display: table-cell;
    line-height: 30px;
    font-weight: 500;
  }
  ul li a {
    text-decoration: none !important;
  }
`;

export const ContentWrapper = styled(BaseBox)`
  width: 100%;
  padding: 2rem;
  background-color: white;
  display: flex;
  margin-top: 32px;
  margin-bottom: 94px;
  min-height: 900px;
`;

export const LeftMenu = styled(BaseBox)`
  width: ${props => props.width}%;
  display: flex;
  justify-content: start;
  flex-direction: row;
  @media screen and (max-width: 992px) {
    width: ${props => props.mdWidth}%;
    flex-wrap: wrap;
  }
`;

export const RightMenu = styled(BaseBox)`
  width: ${props => props.width}%;
  justify-content: flex-end;
  @media screen and (max-width: 992px) {
    width: ${props => props.mdWidth}%;
    flex-wrap: wrap;
  }
`;

RightMenu.propTypes = {
  width: PropTypes.number.isRequired,
  mdWidth: PropTypes.number
};

RightMenu.defaultProps = {
  mdWidth: 0
};

export const MenuItem = styled.li`
  span {
    padding: 5px 12px 5px 0;
  }
  a {
    padding: 5px 12px;
    color: ${props => (props.isSelected ? '#2a2c2e' : 'white')} !important;
    background-color: ${props =>
      props.isSelected ? 'white' : '#4b286d'} !important;
  }
`;

MenuItem.propTypes = {
  isSelected: PropTypes.bool
};

MenuItem.defaultProps = {
  isSelected: false
};

export const Box = styled(BaseBox)`
  width: ${props => props.width}%;
  display: ${props => props.display};
  flex-direction: ${props => props.flexDirection};
  flex-wrap: ${props => props.flexWrap};
  justify-content: ${props => props.justifyContent};
  padding-bottom: ${props => props.pb}px;
  padding-top: ${props => props.pt}px;
  padding-right: ${props => props.pr}px;
  padding-left: ${props => props.pl}px;
  margin-right: ${props => props.mr}px;

  @media screen and (max-width: 992px) {
    width: ${props => props.mdWidth}%;
    justify-content: ${props => props.mdJustifyContent};
    padding: ${props => props.mdPadding};
  }
`;

export const LinkButton = styled.button`
  background: none !important;
  border: none;
  padding: 0 !important;
  margin: 0 5px;
  text-decoration: underline;
  cursor: pointer;
  &:hover {
  }
`;

export const Button = styled.button`
  border: none;
  color: white;
  cursor: pointer;
  text-decoration: underline;
  background: none;
`;

export const FormBox = styled.div`
  width: 100%;
  position: relative;
`;

export const CrossPlatformNavigationButton = styled.span`
  color: white;
  cursor: pointer;
`;

export const HomeLink = styled(Link)`
  text-decoration: none !important;
  > span {
    &:hover {
      color: white;
    }
  }
`;

export const Text = styled.span`
  color: #2a2c2e;
  word-wrap: break-word;
  font-size: 1rem;
  letter-spacing: -0.8px;
  line-height: 1.5;
  font-weight: 700;
`;
